<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardfive.mechanical_part') }}</div>
      <div class="hardware-li">{{ $t('hardfive.internal_dimensions') }}</div>
      <div class="hardware-li">{{ $t('hardfive.external_dimensions') }}</div>
      <div class="hardware-li">{{ $t('hardfive.dimensions_customizable') }}</div>
      <div class="hardware-title">{{ $t('hardfive.electrical_part') }}</div>
      <div class="hardware-li">{{ $t('hardfive.power') }}</div>
      <div class="hardware-li">{{ $t('hardfive.power_consumption') }}</div>
      <div class="hardware-li">{{ $t('hardfive.control_system') }}</div>
      <div class="hardware-li">{{ $t('hardfive.pc_specifications') }}</div>
      <div class="hardware-li">{{ $t('hardfive.collision_prevention_sensor') }}</div>
      <div class="hardware-li">{{ $t('hardfive.alarm_light') }}</div>
      <div class="hardware-li">{{ $t('hardfive.weighing_accuracy') }}</div>
      <div class="hardware-title">{{ $t('hardfive.rfid_part') }}</div>
      <div class="hardware-li">{{ $t('hardfive.reader_model') }}</div>
      <div class="hardware-li">{{ $t('hardfive.antenna_model') }}</div>
      <div class="hardware-li">{{ $t('hardfive.detection_quantity') }}</div>
      <div class="hardware-li">{{ $t('hardfive.shielding_method') }}</div>
      <div class="hardware-li">{{ $t('hardfive.shielding_performance') }}</div>
      <div class="hardware-li">{{ $t('hardfive.customizable_doors') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>